var occ3Observer = new MutationObserver(function(){
  var drawer = document.getElementById('occ3-drawer');
  if (!drawer) return;

  if (drawer.classList.contains('occ3-display-block')) {
    document.querySelectorAll('.spurit-occ3__item-titles').forEach(function(box){
      var variant = box.querySelector('.spurit-occ3__item-variant-title');
      if (variant && !variant.dataset.sizeFormatted) {
        variant.dataset.sizeFormatted = "1";
        variant.innerHTML =
          '<strong style="font-style:normal !important;line-height:1 !important;">Size:</strong> ' +
          variant.textContent.trim();

        variant.style.setProperty('font-style', 'normal', 'important');
        variant.style.setProperty('line-height', '1', 'important');
      }

      box.querySelectorAll('.occ3-properties').forEach(function(p){
        if (p.dataset.formatted) return;
        p.dataset.formatted = "1";

        var txt = p.textContent.trim();
        var parts = txt.split(':');
        if (parts.length < 2) return;

        var title = parts[0].trim();
        var value = parts[1].trim();

        var items = value
          .replace(/\s*\|\s*/g, ' ')
          .split(',')
          .map(function(v){
            v = v.trim();

            if (title.toLowerCase().includes('choose') && title.toLowerCase().includes('color')) {
              var m = v.match(/^(.*?)(\d+)\s+(\d+)$/);
              if (m) return m[1].trim() + ' ' + m[2] + ', QTY: ' + m[3];

              var m2 = v.match(/^(.*?)(\d+)$/);
              if (m2) return m2[1].trim() + ', QTY: ' + m2[2];
            }

            return v;
          })
          .filter(Boolean)
          .join('<br>');

        p.innerHTML =
          '<strong style="font-style:normal !important;line-height:1 !important;">' +
          title +
          ':</strong><br>' +
          items;

        p.style.setProperty('font-style', 'normal', 'important');
        p.style.setProperty('line-height', '1', 'important');
      });
    });
  }
});

occ3Observer.observe(document.body, { attributes: true, subtree: true });

document.addEventListener('click', function(e){
  var btn = e.target.closest('.tpo_add-to-cart');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var form = btn.closest('form');
  if (!form) return;

  var data = new FormData(form);
  data.append('sections', 'cart-drawer');
  data.append('sections_url', window.location.pathname);

  fetch('/cart/add.js', { method: 'POST', body: data })
    .then(function(r){ return r.json(); })
    .then(function(){
      if (window.Spurit && Spurit.OneClickCheckout3 && Spurit.OneClickCheckout3.cartDrawer) {
        Spurit.OneClickCheckout3.cartDrawer.show();
        Spurit.OneClickCheckout3.cartDrawer.refresh();
      }
    });
});

